/*
 * @Author: liyifan
 * @Date: 2024-06-19 16:46:32
 * @Last Modified by: liyifan
 * @Last Modified time: 2024-08-30 15:25:44
 * @description: 首页-产品推荐
 */
import { isMobile} from '@utils/index.js'
export class ProductsSwiper {
    constructor({el, clas}) {
        this.Dom = {
            el: el,
            clas: clas
        }
        this.init();
        this.initGaAttribute()
    }
    init() {
        const swiperFlag = this.Dom.el.data('swiper')
        if (swiperFlag) {
            const slides = this.Dom.el.find('.swiper-slide').length
            // PC小于4个时，不显示操作
            let flag = true
            if (!isMobile()) {
                if (slides <= 4) {
                    this.Dom.el.find('.swiper-operate').hide() 
                    flag = false
                }
            }
            
            // product
            new Swiper( `.${this.Dom.clas}-swiper`, {
                spaceBetween: 16,
                slidesPerView: 1.2,
                breakpoints: {
                    1024: {
                        spaceBetween: 20,
                        slidesPerView: 4
                    },
                },
                loop: flag,
                lazy: {
                    loadPrevNext: true, // 只提前加载下一个
                },
                pagination: {
                    el: `.${this.Dom.clas}-pagination`,
                    type: isMobile() ? "bullets" : "fraction"
                },
                navigation: {
                    nextEl: `.${this.Dom.clas}-next`,
                    prevEl: `.${this.Dom.clas}-prev`,
                },
            });
        }
    }
    initGaAttribute() {
         $('.index-new-products .product-content').each(function() {
            const imgUrl = $(this).find('.content-info  .icons img').attr('src')
            const text = $(this).find('.content-info  .icons .text').text().trim()
            $(this).attr('data-ga-params-button_name', imgUrl ? 'pic_subscript' : '')
            $(this).attr('data-ga-params-content', text)
         })
    }
} 
